import styled, {css} from 'styled-components';
import {ScrollBar} from '../../shared-components/mixin/scroll/scrollBar.js';

export const ModalContainer = styled(ScrollBar)`
    @-moz-document url-prefix() {
        ${({overflowNone}) =>
            overflowNone
                ? css`
                      overflow-x: hidden;
                      overflow-y: hidden;
                  `
                : css`
                      overflow-x: hidden;
                      overflow-y: auto;
                  `}
        scrollbar-color: var(--scroll-bar-thumb-moz) var(--scroll-bar-thumb);
    }
    background: var(--app-background);
    box-shadow: var(--container-shadow-color-400);

    border-radius: var(--modal-border-radius);
    pointer-events: fill;
    position: relative;
    z-index: var(--z-index-modal-container);
    margin: auto;
    max-height: calc(100vh - (2 * var(--space-xxl)));
    width: 100%;
    display: grid;
    grid-template-areas: 'modalContent' 'modalGimmik';
    grid-template-rows: 1fr auto;

    ${({size}) => {
        if (size === 'fixedHeight')
            return css`
                height: calc(100vh - (2 * var(--space-xxl)));
            `;
        if (size === 'sm')
            return css`
                max-width: 600px;
                width: 100%;
            `;
        if (size === 'xsm')
            return css`
                max-width: 600px;
                width: 100%;
            `;
    }}
`;
